import useHasAccess from "@hooks/useHasAccess"
import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { Hint, Icon, IconButton } from "@atoms"

import useJobTimelineViewData from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewData"
import useJobTimelineViewStates from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewStates"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

import styles from "./UnscheduledJobsHeader.module.scss"

export default function UnscheduledJobsHeader() {
    const isDesktop = useIsDesktop()
    const { unscheduledJobsColumnStatus, unscheduledJobsColumnMessageStatus, collapseUnscheduledJobsColumn } =
        useJobTimelineViewStates()

    const { unscheduledJobsCount } = useJobTimelineViewData()

    const { hasPermission } = useHasAccess()

    if (
        unscheduledJobsColumnStatus === "collapsed" ||
        !isDesktop ||
        !hasPermission("jobs_edit_permission", PERMISSION_LEVEL.FULL)
    ) {
        return null
    } else {
        return (
            <div className={styles.base}>
                <div className={styles.questionMarkAndTitle}>
                    {unscheduledJobsColumnMessageStatus !== "initial" && (
                        <Hint
                            colorScheme="blue"
                            title="Unscheduled Jobs"
                            body="We currently only support scheduling Unscheduled jobs from the side panel. To manage Draft, Past Due, and On Hold jobs, switch to Table view."
                            defaultPlacement="bottom"
                        >
                            <div className={styles.questionMark}>
                                <Icon
                                    icon={faIcon({ name: "circle-question", style: "regular" })}
                                    iconOnMouseOver={faIcon({ name: "circle-question", style: "solid" })}
                                />
                            </div>
                        </Hint>
                    )}
                    <div className={styles.title}>{unscheduledJobsCount} Unscheduled Jobs</div>
                </div>

                <div className={styles.button}>
                    <IconButton
                        size="lg"
                        variant="ghost"
                        icon={faIcon({ name: "arrow-right-to-line", style: "regular" })}
                        onClick={collapseUnscheduledJobsColumn}
                        aria-label="Collapse Unscheduled Jobs"
                        noDebounce={true}
                    />
                </div>
            </div>
        )
    }
}
